import React from "react";
import { connect } from "react-redux";
import { styled } from "@acko-tech/building-blocks.ui.common";

import ImageContainer from "@components/imageContainer";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import DOMPurify from "isomorphic-dompurify";

export interface IBannerV2 extends CommonProps {
  type?: "DANGER";
  text: string;
  image?: any; 
}

const Container = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  box-sizing: border-box;

  color: #36354c;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;

  border-radius: 12px;
  border-radius: 0 0 8px 8px;
  border: 1px solid var(--Purple-P50, #EFE9FB);
  background: #F9F6FF;
  ${(props) =>
    props.type === "DANGER" &&
    `
    background: linear-gradient(94deg, rgba(255, 238, 238, 0.70) 0%, rgba(255, 242, 242, 0.70) 99.67%);
    `}

  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }

  ${(props) => props.styles}
`;

const BannerText = styled.div`
  margin-top: 8px;
`;

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const BannerV2 = (props: IBannerV2) => {
  const { is_visible, text, styles, image, type, id } = props;

  const { imgSrc, height, width, alt } = image || {};

  return (id && is_visible) || !id ? (
    <Container styles={styles} type={type}>
      {imgSrc && (
        <div style={{ minWidth: width }}>
          <ImageContainer
            imgSrc={imgSrc}
            height={height}
            width={width}
            alt={alt}
          />
        </div>
      )}

      <BannerText
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(text)
        }}
      ></BannerText>
    </Container>
  ) : null;
};

export default connect(mapStateToProps)(BannerV2);
